import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {GreatForm} from 'components/common';
import SelectField from '../common/rc-fields/SelectField';
import {fetchAllUserClassrooms, fetchAllClassroomsForUserToMoveTo, moveUserToAnotherClassroom} from 'api/classrooms';

const MoveUserToClassroomForm = ({userId, form, onSubmitSuccess}) => {
  const [userClassrooms, setUserClassrooms] = useState([]);
  const [classroomsToMoveTo, setClassroomsToMoveTo] = useState([]);

  useEffect(() => {
    fetchAllUserClassrooms(userId).then(({records}) => setUserClassrooms(records));
    fetchAllClassroomsForUserToMoveTo(userId).then(({records}) => setClassroomsToMoveTo(records));
  }, []);

  return (
    <GreatForm
      form={form}
      submitFn={(payload) => moveUserToAnotherClassroom(userId, payload)}
      onSuccess={onSubmitSuccess}
      successMsg="Students successfully imported to the classroom"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SelectField
            name="fromClassroomId"
            label="From Classroom"
            options={userClassrooms}
            labelKey="name"
            valueKey="id"
            rules={[{required: true, message: 'Please select a classroom to move from'}]}
            form={form}
            autoComplete="off"
            renderValue={(classroomId) => userClassrooms.find(({id}) => id === classroomId).name}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectField
            name="toClassroomId"
            label="To Classroom"
            options={classroomsToMoveTo}
            labelKey="name"
            valueKey="id"
            rules={[{required: true, message: 'Please select a classroom to move to'}]}
            form={form}
            autoComplete="off"
            renderValue={(classroomId) => classroomsToMoveTo.find(({id}) => id === classroomId).name}
          />
        </Grid>
      </Grid>
    </GreatForm>
  );
};

MoveUserToClassroomForm.propTypes = {
  form: formShape.isRequired,
  userId: PropTypes.number.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
};

export default createForm()(MoveUserToClassroomForm);
